<template>
  <div class="container">
    <!-- pc端 -->
    <div v-if="!$deviceState.isMobile" :class="deviceClass">
      <div class="left">
        <img src="@/assets/imgs/logo.png" alt="" />
        <h1 class="font56">昌恩<span class="orangeTxt">智</span>控</h1>
        <h2 class="font56">投资回报预算系统</h2>
        <p class="copyright">©深圳昌恩智能股份有限公司版权所有</p>
        <p class="bottomTxt">粤ICP备17113788号</p>
      </div>
      <div class="right">
        <p class="welcome">欢迎登录</p>
        <div class="accountPassword font20">
          <p :class="{ active: flag }" @click="switchAccountLogin">
            账号密码登录
          </p>
          <!-- <p :class="{ active: !flag }" @click="switchQrLogin">扫码登陆</p> -->
          <!-- <p :class="{ active: !flag }" @click="registerAccount">立即注册</p> -->
        </div>
        <!-- 动态组件 -->
        <keep-alive include="AccountPassword">
          <component :is="loginMode"></component>
        </keep-alive>
      </div>
    </div>

    <!-- 移动端 -->
    <div v-else :class="deviceClass">
      <div class="left">
        <img src="@/assets/imgs/logo.png" alt="" />
        <h1 class="font56">昌恩<span class="orangeTxt">智</span>控</h1>
        <h2 class="font56">投资回报预算系统</h2>
      </div>
      <div class="right">
        <!-- <p class="welcome">欢迎登录</p> -->
        <div class="accountPassword font20">
          <!-- <p :class="{ active: flag }" @click="switchAccountLogin">
            账号密码登录
          </p> -->
          <!-- <p :class="{ active: !flag }" @click="switchQrLogin">扫码登陆</p> -->
          <!-- <p :class="{ active: !flag }" @click="registerAccount">立即注册</p> -->
        </div>
        <!-- 动态组件 -->
        <keep-alive include="mobileAccountPassword">
          <component :is="mobileLoginMode"></component>
        </keep-alive>
      </div>

      <div class="bottom">
        <p class="copyright">©深圳昌恩智能股份有限公司版权所有</p>
        <p class="bottomTxt">粤ICP备17113788号</p>
      </div>
    </div>
  </div>
</template>

<script>
import AccountPassword from '@/components/login/accountPassword.vue'
import QrCode from '@/components/login/qrCode.vue'
import RegisterAccount from '@/components/login/registerAccount.vue'
import mobileAccountPassword from '@/views/mobile/accountPassword.vue'

export default {
  name: 'loginPage',
  components: {
    AccountPassword,
    QrCode,
    RegisterAccount,
    mobileAccountPassword
  },
  data () {
    return {
      loginMode: AccountPassword,
      mobileLoginMode: mobileAccountPassword,
      flag: true,
      checked: false
    }
  },
  // computed: {
  //   deviceClass () {
  //     return this.$deviceState.isMobile ? 'mb_area' : 'pc_area'
  //   }
  // },
  mounted () {
    // 判断移动端设备
    console.log('当前设备是移动端：', this.$deviceState.isMobile)
    // 禁止缩放
    // this.zoomDisable()
  },
  methods: {
    switchAccountLogin () {
      this.flag = true

      this.loginMode = AccountPassword
    },
    switchQrLogin () {
      this.flag = false
      this.loginMode = QrCode
    },
    // 注册账号
    registerAccount () {
      this.flag = false
      this.loginMode = RegisterAccount
    },
    zoomDisable () {
      document.addEventListener(
        'wheel',
        function (event) {
          if (event.ctrlKey) {
            event.preventDefault()
          }
        },
        { passive: false }
      )
    }
  }
}
</script>

<style lang="less" scoped>
html {
  font-size: 16px;
}
.container {
  width: 100%;
  height: 100vh;
  background: url('https://img.forwayapp.com/bg_myek_v3.png') no-repeat;
  background-size: cover;
}

@media (min-width: 769px) and (max-width: 1364px) {
  html {
    font-size: 12px;
  }
  .pc_area {
    width: 80% !important;
    height: 60% !important;
    h1,
    h2 {
      font-size: 40px;
    }
    .left {
      padding-top: 0px !important;
      padding-left: 6px !important;
    }
    .left img {
      width: 127px;
      height: 127px;
      object-fit: contain;
    }
    .right .welcome {
      font-size: 38px !important;
    }
  }
}
.pc_area {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 1360px;
  height: 612px;
  transform: translate(-50%, -50%);
  background: #001372 url(https://img.forwayapp.com/bg_login_box_v3.png)
    no-repeat center;
  background-size: 100%;
  border-radius: 10px;
  border: 2px solid hsla(0, 0%, 100%, 0.2);
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .left {
    padding-top: 20px;
    padding-left: 70px;
  }
  .left img {
    width: 127px;
    height: 127px;
    object-fit: contain;
  }
  .left h1,
  h2 {
    color: #fff;
  }
  .orangeTxt {
    color: #f39800;
    transform: skew(-20deg);
  }
  .left .copyright {
    margin-top: 100px;
  }
  .left p {
    font-size: 14px;
    color: #8093cc;
  }
  .left .bottomTxt {
    font-size: 10px;
    margin-top: 14px;
  }
  .right {
    position: relative;
    box-sizing: border-box;
    width: 39%;
    height: 108%;
    border-radius: 2px;
    background: linear-gradient(306deg, #010a3c, #00126d);
    box-shadow: 4px 4px 6px 2px rgba(0, 0, 0, 0.25);
    border: 3px solid hsla(0, 0%, 100%, 0.2);
    border-radius: 12px;
    overflow: hidden;
    margin-left: -40px;
    padding: 40px;
  }
  .right::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 6px;
    background: linear-gradient(306deg, #ff7a00, #ffb800);
    border-radius: 12px 12px 0 0;
  }

  .right .welcome {
    font-size: 48px;
    font-weight: 600;
    text-align: left;
    color: #4387ff;
  }

  .right .accountPassword {
    display: flex;
    justify-content: space-between;
    font-weight: 600;
    margin-top: 50px;
    cursor: pointer;
  }
  .accountPassword p {
    color: hsla(0, 0%, 100%, 0.5);
  }
  .accountPassword .active {
    color: #ffc700;
    font-size: 24px;
    padding-bottom: 16px;
    border-bottom: 2px solid #ffc700;
  }
}

.mb_area {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  height: 100vh;
  transform: translate(-50%, -50%);
  background: #001372 url(https://img.forwayapp.com/bg_login_box_v3.png)
    no-repeat center;
  background-size: 100%;
  // border-radius: 10px;
  // border: 2px solid hsla(0, 0%, 100%, 0.2);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .left img {
    width: 24em;
    height: 24em;
    object-fit: contain;
  }
  .left h1,
  h2 {
    font-size: 8em;
    color: #fff;
  }
  .orangeTxt {
    color: #f39800;
    transform: skew(-20deg);
  }
  .left .copyright {
    margin-top: 2em;
  }

  .right {
    position: relative;
    box-sizing: border-box;
    width: 90%;
    min-height: 300px;
    border-radius: 2px;
    background: linear-gradient(306deg, #010a3c, #00126d);
    box-shadow: 4px 4px 6px 2px rgba(0, 0, 0, 0.25);
    border: 3px solid hsla(0, 0%, 100%, 0.2);
    border-radius: 12px;
    overflow: auto;
    padding: 20px;
    margin: 6em auto;
  }
  .right::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 6px;
    background: linear-gradient(306deg, #ff7a00, #ffb800);
    border-radius: 12px 12px 0 0;
  }

  .bottom {
    margin-top: 30px;
  }
  .bottom p {
    font-size: 3em;
    color: #8093cc;
  }
  .bottom .bottomTxt {
    font-size: 2.5em;
    margin-top: 1em;
  }
  // .right .welcome {
  //   font-size: 48px;
  //   font-weight: 600;
  //   text-align: left;
  //   color: #4387ff;
  // }

  // .right .accountPassword {
  //   display: flex;
  //   justify-content: space-between;
  //   font-weight: 600;
  //   margin-top: 50px;
  //   cursor: pointer;
  // }
  // .accountPassword p {
  //   color: hsla(0, 0%, 100%, 0.5);
  // }
  // .accountPassword .active {
  //   color: #ffc700;
  //   font-size: 24px;
  //   padding-bottom: 16px;
  //   border-bottom: 2px solid #ffc700;
  // }
}
</style>
